import {
  ADD_ADMINISTRATOR,
  ADD_ADMINISTRATOR_FAILED,
  ADD_ADMINISTRATOR_SUCCESS,

  CREATE_ADMINISTRATOR_PASSWORD,
  CREATE_ADMINISTRATOR_PASSWORD_FAILED,
  CREATE_ADMINISTRATOR_PASSWORD_SUCCESS,

  DELETE_ADMINISTRATOR,
  DELETE_ADMINISTRATOR_FAILED,
  DELETE_ADMINISTRATOR_SUCCESS,

  EDIT_ADMINISTRATOR,
  EDIT_ADMINISTRATOR_SUCCESS,
  EDIT_ADMINISTRATOR_FAILED,

  GET_ACTION_HISTORY_LIST,
  GET_ACTION_HISTORY_LIST_FAILED,
  GET_ACTION_HISTORY_LIST_SUCCESS,

  GET_ADMINISTRATORS_LIST,
  GET_ADMINISTRATORS_LIST_FAILED,
  GET_ADMINISTRATORS_LIST_SUCCESS,

  GET_EXTRANET_ADMINISTRATORS_LIST,
  GET_EXTRANET_ADMINISTRATORS_LIST_FAILED,
  GET_EXTRANET_ADMINISTRATORS_LIST_SUCCESS,

  GET_ADMINISTRATORS_DETAIL,
  GET_ADMINISTRATORS_DETAIL_SUCCESS,
  GET_ADMINISTRATORS_DETAIL_FAILED,

  GET_MY_PERMISSION,
  GET_MY_PERMISSION_SUCCESS,
  GET_MY_PERMISSION_FAILED,

  GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER,
  GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER_SUCCESS,
  GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER_FAILED,

  EDIT_EXTRANET_ADMINISTRATOR,
  EDIT_EXTRANET_ADMINISTRATOR_SUCCESS,
  EDIT_EXTRANET_ADMINISTRATOR_FAILED,

  DELETE_EXTRANET_ADMINISTRATOR,
  DELETE_EXTRANET_ADMINISTRATOR_SUCCESS,
  DELETE_EXTRANET_ADMINISTRATOR_FAILED,

  RESET_EXTRANET_ADMINISTRATOR_PASSWORD,
  RESET_EXTRANET_ADMINISTRATOR_PASSWORD_SUCCESS,
  RESET_EXTRANET_ADMINISTRATOR_PASSWORD_FAILED,

  CHECK_EXTRANET_EMAIL,
  CHECK_EXTRANET_EMAIL_SUCCESS,
  CHECK_EXTRANET_EMAIL_FAILED,

  ADD_EXTRANET_ADMINISTRATOR,
  ADD_EXTRANET_ADMINISTRATOR_SUCCESS,
  ADD_EXTRANET_ADMINISTRATOR_FAILED,

  RESET_INTRANET_ADMINISTRATOR_PASSWORD,
  RESET_INTRANET_ADMINISTRATOR_PASSWORD_SUCCESS,
  RESET_INTRANET_ADMINISTRATOR_PASSWORD_FAILED,
} from './actionTypes';

// GET ADMINISTRATORS LIST
export const actionGetAdministratorsList = (payload) => ({
  payload,
  type: GET_ADMINISTRATORS_LIST,
});

export const actionGetAdministratorsListSuccess = (payload) => ({
  payload,
  type: GET_ADMINISTRATORS_LIST_SUCCESS,
});

export const actionGetAdministratorsListFailed = (payload) => ({
  payload,
  type: GET_ADMINISTRATORS_LIST_FAILED,
});

// GET EXTRANET ADMINISTRATORS LIST
export const actionGetExtranetAdministratorsList = (payload) => ({
  payload,
  type: GET_EXTRANET_ADMINISTRATORS_LIST,
});

export const actionGetExtranetAdministratorsListSuccess = (payload) => ({
  payload,
  type: GET_EXTRANET_ADMINISTRATORS_LIST_SUCCESS,
});

export const actionGetExtranetAdministratorsListFailed = (payload) => ({
  payload,
  type: GET_EXTRANET_ADMINISTRATORS_LIST_FAILED,
});

// GET ADMINISTRATORS LIST
export const actionGetAdministratorsDetail = (payload) => ({
  payload,
  type: GET_ADMINISTRATORS_DETAIL,
});

export const actionGetAdministratorsDetailSuccess = (payload) => ({
  payload,
  type: GET_ADMINISTRATORS_DETAIL_SUCCESS,
});

export const actionGetAdministratorsDetailFailed = (payload) => ({
  payload,
  type: GET_ADMINISTRATORS_DETAIL_FAILED,
});

// ADD ADMINISTRATOR
export const actionAddAdministrator = (payload) => ({
  payload,
  type: ADD_ADMINISTRATOR,
});

export const actionAddAdministratorSuccess = (payload) => ({
  payload,
  type: ADD_ADMINISTRATOR_SUCCESS,
});

export const actionAddAdministratorFailed = (payload) => ({
  payload,
  type: ADD_ADMINISTRATOR_FAILED,
});

// CREATE ADMINISTRATOR PASSWORD
export const actionCreateAdministratorPassword = (payload) => ({
  payload,
  type: CREATE_ADMINISTRATOR_PASSWORD,
});

export const actionCreateAdministratorPasswordSuccess = (payload) => ({
  payload,
  type: CREATE_ADMINISTRATOR_PASSWORD_SUCCESS,
});

export const actionCreateAdministratorPasswordFailed = (payload) => ({
  payload,
  type: CREATE_ADMINISTRATOR_PASSWORD_FAILED,
});

// DELETE ADMINISTRATOR
export const actionDeleteAdministrator = (payload) => ({
  payload,
  type: DELETE_ADMINISTRATOR,
});

export const actionDeleteAdministratorSuccess = (payload) => ({
  payload,
  type: DELETE_ADMINISTRATOR_SUCCESS,
});

export const actionDeleteAdministratorFailed = (payload) => ({
  payload,
  type: DELETE_ADMINISTRATOR_FAILED,
});

// EDIT ADMINISTRATOR
export const actionEditAdministrator = (payload) => ({
  payload,
  type: EDIT_ADMINISTRATOR,
});

export const actionEditAdministratorSuccess = (payload) => ({
  payload,
  type: EDIT_ADMINISTRATOR_SUCCESS,
});

export const actionEditAdministratorFailed = (payload) => ({
  payload,
  type: EDIT_ADMINISTRATOR_FAILED,
});

// GET ACTION HISTORY LIST
export const actionGetActionHistoryList = (payload) => ({
  payload,
  type: GET_ACTION_HISTORY_LIST,
});

export const actionGetActionHistoryListSuccess = (payload) => ({
  payload,
  type: GET_ACTION_HISTORY_LIST_SUCCESS,
});

export const actionGetActionHistoryListFailed = (payload) => ({
  payload,
  type: GET_ACTION_HISTORY_LIST_FAILED,
});

// GET MY PERMISSION
export const actionGetMyPermission = (payload) => ({
  payload,
  type: GET_MY_PERMISSION,
});

export const actionGetMyPermissionSuccess = (payload) => ({
  payload,
  type: GET_MY_PERMISSION_SUCCESS,
});

export const actionGetMyPermissionFailed = (payload) => ({
  payload,
  type: GET_MY_PERMISSION_FAILED,
});

// GET EXTRANET ADMINISTRATORS PLACE MANAGER
export const actionGetExtranetAdministratorsPlaceManager = (payload) => ({
  payload,
  type: GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER,
});

export const actionGetExtranetAdministratorsPlaceManagerSuccess = (payload) => ({
  payload,
  type: GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER_SUCCESS,
});

export const actionGetExtranetAdministratorsPlaceManagerFailed = (payload) => ({
  payload,
  type: GET_EXTRANET_ADMINISTRATORS_PLACE_MANAGER_FAILED,
});

// EDIT EXTRANET ADMINISTRATOR
export const actionEditExtranetAdministrator = (payload) => ({
  payload,
  type: EDIT_EXTRANET_ADMINISTRATOR,
});

export const actionEditExtranetAdministratorSuccess = (payload) => ({
  payload,
  type: EDIT_EXTRANET_ADMINISTRATOR_SUCCESS,
});

export const actionEditExtranetAdministratorFailed = (payload) => ({
  payload,
  type: EDIT_EXTRANET_ADMINISTRATOR_FAILED,
});

// DELETE EXTRANET ADMINISTRATOR
export const actionDeleteExtranetAdministrator = (payload) => ({
  payload,
  type: DELETE_EXTRANET_ADMINISTRATOR,
});

export const actionDeleteExtranetAdministratorSuccess = (payload) => ({
  payload,
  type: DELETE_EXTRANET_ADMINISTRATOR_SUCCESS,
});

export const actionDeleteExtranetAdministratorFailed = (payload) => ({
  payload,
  type: DELETE_EXTRANET_ADMINISTRATOR_FAILED,
});

// CHECK EXTRANET EMAIL
export const actionCheckExtranetEmail = (payload) => ({
  payload,
  type: CHECK_EXTRANET_EMAIL,
});

export const actionCheckExtranetEmailSuccess = (payload) => ({
  payload,
  type: CHECK_EXTRANET_EMAIL_SUCCESS,
});

export const actionCheckExtranetEmailFailed = (payload) => ({
  payload,
  type: CHECK_EXTRANET_EMAIL_FAILED,
});

// ADD EXTRANET ADMINISTRATOR
export const actionAddExtranetAdministrator = (payload) => ({
  payload,
  type: ADD_EXTRANET_ADMINISTRATOR,
});

export const actionAddExtranetAdministratorSuccess = (payload) => ({
  payload,
  type: ADD_EXTRANET_ADMINISTRATOR_SUCCESS,
});

export const actionAddExtranetAdministratorFailed = (payload) => ({
  payload,
  type: ADD_EXTRANET_ADMINISTRATOR_FAILED,
});

// RESET EXTRANET ADMINISTRATOR PASSWORD
export const actionResetExtranetAdministratorPassword = (payload) => ({
  payload,
  type: RESET_EXTRANET_ADMINISTRATOR_PASSWORD,
});

export const actionResetExtranetAdministratorPasswordSuccess = (payload) => ({
  payload,
  type: RESET_EXTRANET_ADMINISTRATOR_PASSWORD_SUCCESS,
});

export const actionResetExtranetAdministratorPasswordFailed = (payload) => ({
  payload,
  type: RESET_EXTRANET_ADMINISTRATOR_PASSWORD_FAILED,
});

// RESET INTRANET ADMINISTRATOR PASSWORD
export const actionResetIntranetAdministratorPassword = (payload) => ({
  payload,
  type: RESET_INTRANET_ADMINISTRATOR_PASSWORD,
});

export const actionResetIntranetAdministratorPasswordSuccess = (payload) => ({
  payload,
  type: RESET_INTRANET_ADMINISTRATOR_PASSWORD_SUCCESS,
});

export const actionResetIntranetAdministratorPasswordFailed = (payload) => ({
  payload,
  type: RESET_INTRANET_ADMINISTRATOR_PASSWORD_FAILED,
});
